import { lazy, Suspense } from "react";
import { Route, Switch } from "react-router-dom";

import { LoadingSpinner } from "@/design-system/components/LoadingSpinner/LoadingSpinner";
import { NavigationLayoutProvider } from "@/NavBar/NavigationLayoutContext";

const HeatmapsListPage = lazy(() => import("./HeatmapsListPage"));
const HeatmapsViewerPage = lazy(() => import("./HeatmapsViewerPage"));

export default function HeatmapsPocPreview() {
  return (
    <NavigationLayoutProvider>
      <div className="min-h-screen bg-white p-8">
        <div className="mx-auto max-w-[1280px]">
          <div className="mb-6 flex items-center gap-3 rounded-lg border border-amber-200 bg-amber-50 px-4 py-3 text-xs text-amber-900">
            <span className="rounded-full bg-amber-200 px-2 py-0.5 font-semibold tracking-wide uppercase">
              Preview
            </span>
            <span>
              Unauthenticated POC preview of the Heatmaps feature. Mock data
              only.
            </span>
          </div>
          <Suspense fallback={<LoadingSpinner />}>
            <Switch>
              <Route
                path="/heatmaps-poc-preview/:pageId"
                exact
                component={HeatmapsViewerPage}
              />
              <Route
                path="/heatmaps-poc-preview"
                exact
                component={HeatmapsListPage}
              />
            </Switch>
          </Suspense>
        </div>
      </div>
    </NavigationLayoutProvider>
  );
}
